import { forwardRef } from "react"
import { withMask } from "use-mask-input"

import { Input } from "./input"
type InputMoneyProps = React.InputHTMLAttributes<HTMLInputElement>
export const InputMoney = forwardRef<HTMLInputElement, InputMoneyProps>(
  (props, ref) => {
    return (
      <Input
        {...props}
        type="text"
        ref={(input) => {
          if (input) {
            withMask(
              [
                "R$ 9,99",
                "R$ 99,99",
                "R$ 999,99",
                "R$ 9.999,99",
                "R$ 99.999,99",
                "R$ 999.999,99",
                "R$ 9.999.999,99",
                "R$ 99.999.999,99",
                "R$ 999.999.999,99",
                "R$ 9.999.999.999,99",
                "R$ 99.999.999.999,99",
                "R$ 999.999.999.999,99",
              ],
              {
                placeholder: "R$ 0,00",
                showMaskOnHover: false,
              },
            )(input)
          }
          if (typeof ref === "function") {
            ref(input)
          } else if (ref) {
            ref.current = input
          }
        }}
      />
    )
  },
)
InputMoney.displayName = "InputMoney"
